import { useQuery } from "@tanstack/react-query";
import { Users } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ROLE_LABEL = { master_admin: "Master Admin", admin: "Admin", mis: "MIS Executive", management: "Management" };

export function OnlineUsers() {
  const { user } = useAuth();
  const allowed = user && ["master_admin", "admin", "management"].includes(user.role);
  const q = useQuery({
    queryKey: ["online-users"],
    queryFn: async () => (await api.get("/auth/online")).data,
    refetchInterval: 30_000,
    enabled: !!allowed,
  });
  if (!allowed) return null;
  const users = q.data?.users || [];
  return (
    <div className="pp-card p-5 rise rise-2" data-testid="online-users-card">
      <div className="flex items-center justify-between mb-3">
        <div className="pp-label flex items-center gap-2"><Users size={14} /> Logged in now</div>
        <span className="flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-mono font-semibold text-emerald-700" data-testid="online-users-count">
          <span className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />{q.data?.count ?? "—"} online
        </span>
      </div>
      {!users.length && <div className="text-sm text-slate-500">No active users</div>}
      <div className="flex flex-wrap gap-2">
        {users.map((u) => (
          <div key={u.id} className="flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5" data-testid={`online-user-${u.id}`}>
            <span className="h-2 w-2 rounded-full bg-emerald-500" />
            <span className="text-sm font-medium text-slate-800">{u.name || u.email}</span>
            <span className="text-[11px] uppercase tracking-wide text-slate-500">{ROLE_LABEL[u.role] || u.role}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
